import { createAsyncThunk } from "@reduxjs/toolkit";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { APP_PATH } from "../../api/backendPath";

import i18n from "../../i18n";
export const getPharmacyChatConversations = createAsyncThunk(
  "pharmacyChatOrders/getConversations",
  async (_, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();
    try {
      const response = await axiosPrivate.get(
        `${process.env.REACT_APP_API_URL}${APP_PATH.pharmacyChatGetConversations}`,
      );
      if (response?.data?.status === true) return response.data;
      return rejectWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || i18n.t("pharmacy.toast.failedToFetchConversations"),
      );
    }
  },
);

export const getPharmacyChatMessages = createAsyncThunk(
  "pharmacyChatOrders/getMessages",
  async ({ conversationKey, page = 1, limit = 50 }, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();
    try {
      const params = new URLSearchParams({
        conversation_key: conversationKey,
        page: page.toString(),
        limit: limit.toString(),
      });
      const response = await axiosPrivate.get(
        `${process.env.REACT_APP_API_URL}${APP_PATH.pharmacyChatGetMessages}?${params.toString()}`,
      );
      if (response?.data?.status === true) return response.data;
      return rejectWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || i18n.t("pharmacy.toast.failedToFetchMessages"),
      );
    }
  },
);

export const sendPharmacyChatMessage = createAsyncThunk(
  "pharmacyChatOrders/sendMessage",
  async ({ receiver_user_id, message }, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();
    try {
      const response = await axiosPrivate.post(
        `${process.env.REACT_APP_API_URL}${APP_PATH.pharmacyChatSendMessage}`,
        { receiver_user_id, message },
      );
      if (response?.data?.status === true) return response.data;
      return rejectWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || i18n.t("pharmacy.toast.failedToSendMessage"),
      );
    }
  },
);

export const createPharmacyChatOrder = createAsyncThunk(
  "pharmacyChatOrders/createOrder",
  async (payload, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();
    try {
      const response = await axiosPrivate.post(
        `${process.env.REACT_APP_API_URL}${APP_PATH.pharmacyChatCreateOrder}`,
        payload,
      );
      if (response?.data?.status === true) return response.data;
      return rejectWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || i18n.t("pharmacy.toast.failedToCreateOrder"),
      );
    }
  },
);
